import * as P from 'fp-ts/Predicate';
import { Profile } from '@modules/profile/model';

export namespace ProfilePredicate {
  export const isAccessLimited: P.Predicate<Profile> = profile => profile.subscription.isAccessLimited;
}
